import { RouteObject } from 'react-router-dom';
import authMappings from './mappings/authMappings';
import appMappings from './mappings/appMapping';

const routes: RouteObject[] = [
  ...authMappings,
  ...appMappings,
];

export default routes;